var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "install-bonus-popup-wrap" }, [
    _c(
      "div",
      {
        staticClass: "ib-popup",
        class: { active: !_vm.isMinimize && _vm.active },
      },
      [
        _c("div", { staticClass: "ib-content" }, [
          _c("p", { staticClass: "title" }, [
            _c("span", [_vm._v(_vm._s(_vm.$t("title_install_bonus")))]),
          ]),
          _c("p", { staticClass: "subtitle" }, [
            _vm._v(_vm._s(_vm.$t("subtitle_install_bonus"))),
          ]),
          _c(
            "div",
            { staticClass: "award-list" },
            _vm._l(5, function (item) {
              return _c("div", {
                key: item,
                staticClass: "item",
                class: `item-${item}`,
              })
            }),
            0
          ),
          _c("div", {
            staticClass: "tips",
            domProps: {
              innerHTML: _vm._s(
                _vm.$t("tips_install_bonus", [
                  `<span>${_vm.$t("title_install_bonus")}</span>`,
                ])
              ),
            },
          }),
        ]),
        _c(
          "a",
          {
            staticClass: "btn-install",
            attrs: { href: "javascript:;" },
            on: { click: _vm.install },
          },
          [_c("span", [_vm._v(_vm._s(_vm.$t("title_install_bonus")))])]
        ),
        _c("a", {
          staticClass: "btn-close",
          attrs: { href: "javascript:;" },
          on: { click: _vm.minimize },
        }),
      ]
    ),
    _c(
      "div",
      {
        staticClass: "ib-popup-s",
        class: { active: _vm.isMinimize },
        on: {
          click: function ($event) {
            _vm.isMinimize = false
          },
        },
      },
      [
        _c("div", { staticClass: "view" }),
        _c("p", { staticClass: "text" }, [
          _vm._v(_vm._s(_vm.$t("btn_receive_award"))),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }